module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x5@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x5@2x.png
// module id = 85
// module chunks = 3